import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { SupplierRequestListObjectType, SupplierRequestType } from '@econtractor/types';
import SpinnerBlock from 'components/others/SpinnerBlock';
import useSupplierRequestSendEmail from '../model/useSupplierRequestSendEmail';
import SupplierRequestsTableBody from './SupplierRequestsTableBody';

interface SupplierRequestsTableProps {
    requests: SupplierRequestType[];
    showSpinner: boolean;
    canOps: boolean;
    onOpen: (requestId: number) => void;
    onClone: (row: SupplierRequestType) => void;
    onChanged: () => void;
    onFilterByObject: (object: SupplierRequestListObjectType) => void;
    showObject: boolean;
    showDate: boolean;
    showUser: boolean;
    showNote: boolean;
}

const SupplierRequestsTable = ({
    requests,
    showSpinner,
    canOps,
    onOpen,
    onClone,
    onChanged,
    onFilterByObject,
    showObject,
    showDate,
    showUser,
    showNote,
}: SupplierRequestsTableProps) => {
    const { t } = useTranslation(['Vendors']);
    const { openSendEmail } = useSupplierRequestSendEmail({ onChanged });
    const tableMinWidth = 330
        + (showObject ? 220 : 0)
        + (showDate ? 160 : 0)
        + (showUser ? 200 : 0)
        + (showNote ? 110 : 0);

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur={true} show={showSpinner} />
            <div className="crm-table-wrap">
                <Table className="SupplierRequestsTable table-hover mb-0 align-middle" style={{ minWidth: tableMinWidth }}>
                    <thead>
                        <tr className="bg-light">
                            <td className="head-vendor">{t('supplierRequests.colVendor')}</td>
                            {showObject ? <td className="head-objects">{t('supplierRequests.colObjects')}</td> : null}
                            <td className="head-status">{t('supplierRequests.colStatus')}</td>
                            {showDate ? <td className="head-date">{t('supplierRequests.colDate')}</td> : null}
                            {showUser ? <td className="head-username">{t('supplierRequests.colUser')}</td> : null}
                            {showNote ? <td className="head-note">{t('supplierRequests.colNote')}</td> : null}
                            <td className="head-action">{t('supplierRequests.colActions')}</td>
                        </tr>
                    </thead>
                    <SupplierRequestsTableBody
                        requests={requests}
                        canOps={canOps}
                        onOpen={onOpen}
                        onClone={onClone}
                        onChanged={onChanged}
                        onSendEmail={openSendEmail}
                        onFilterByObject={onFilterByObject}
                        showObject={showObject}
                        showDate={showDate}
                        showUser={showUser}
                        showNote={showNote}
                    />
                </Table>
            </div>
        </div>
    );
};

export default SupplierRequestsTable;
